<main class="d-flex flex-column flex-grow-1 h-100">
  <div class="d-grid gap-2 d-md-flex justify-content-between gw-header sticky-sm-top">
    <a href="{{ homeUrl }}">
      <img class="logo align-self-center ps-3" src="logo-pending-sales.png" height="70px"
        alt="Groundworks Pending Sales" />
    </a>
    <div class="affiliate col-3 align-self-center text-center">
      <span class="fw-normal" id="selected-branch"></span>
    </div>
    <div class="user-details-wrapper col-2">
      <div class="user-details">
        <div class="user-name">
          @if(!production) {
          <span class="badge badge-pill bg-danger" id="environment-badge">{{ env }}</span>
          }
          <span class="dropdown">
            <button class="btn btn-link dropdown-toggle" data-bs-toggle="dropdown" data-bs-auto-close="true"
              aria-expanded="false">
              {{ whoami() }}
            </button>
            <div class="dropdown-menu" style="z-index: 1100">
              <button class="dropdown-item" (click)="logout()">Logout</button>
            </div>
          </span>
        </div>
        <div class="user-image"></div>
      </div>
    </div>
  </div>
  @if (postLoginAlert(); as message) {
    <div id="post-login-alert" class="alert alert-warning d-flex align-items-center justify-content-between gap-3 m-2" role="alert">
      <span>{{ message }}</span>
      <button type="button" class="btn btn-sm btn-outline-dark text-nowrap" (click)="signInAgain()">Sign in again</button>
    </div>
  }
  <router-outlet />
</main>
